export default {
  cardsSegment: {
    minHeight: '250px',
    padding: 0,
    margin: 0
  }
};